import { GeneratedBuildData } from 'web/data/models'

export const GENERATED_MAIN: GeneratedBuildData = JSON.parse(`
{
    "specsById": {
      "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Tank",
        "name": "Guardian",
        "id": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "shortName": "Guard",
        "icon_name": "ability_racial_bearform",
        "spellIds": [
          "9bc18005-3fb3-435d-9eb6-bc70ad7dcd7f"
        ],
        "talentIds": []
      },
      "67a45712-192e-4916-ad57-d9a13124fea6": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Discipline",
        "id": "67a45712-192e-4916-ad57-d9a13124fea6",
        "shortName": "Disc",
        "icon_name": "spell_holy_powerwordshield",
        "spellIds": [
          "b5b02f28-d5d7-4456-bc5b-d0e61bce57da",
          "7f8c721f-1f23-43b3-8164-dcc2f2715985",
          "c99f217d-2734-423c-aaee-edc5bdb14f81",
          "321d761a-2d39-4dff-a24d-fcb813268dce",
          "9009c1c3-579e-4900-8cab-83f0a19a3cf9",
          "d785b1f4-4e56-48e3-af49-4f0c7c584f16"
        ],
        "talentIds": [
          "bae29c2a-4e98-4335-a4e1-196ba905cace",
          "3e09a8a9-f387-4883-a621-9d984b9ea13e",
          "69341f1a-6471-4a2c-bf46-b17b254fee3f"
        ]
      },
      "72947601-4270-4e1e-b917-25aacaa6d3e0": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Healer",
        "name": "Restoration",
        "id": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "shortName": "Resto",
        "icon_name": "spell_nature_healingtouch",
        "spellIds": [
          "f5893bda-6300-4815-bb54-88b5d402b6a5",
          "35f8b981-e772-4084-a274-d8b0fd875688",
          "03144576-38ad-4511-81d5-755cdf3662fd"
        ],
        "talentIds": [
          "9816f40b-2412-4616-9960-63a6551fe943",
          "eb1dec13-e58d-4f57-96e7-668749613440"
        ]
      },
      "6c233e8c-5bd4-4ece-9fb8-529a1e78759b": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Ranged DPS",
        "name": "Balance",
        "id": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "shortName": "Balance",
        "icon_name": "spell_nature_starfall",
        "spellIds": [
          "62704b34-f28b-4567-8bb1-25c36d930c13"
        ],
        "talentIds": []
      },
      "b72fb4f9-413a-4222-8569-b3cb8e5e67f2": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Frost",
        "id": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2",
        "shortName": "Frost",
        "icon_name": "spell_deathknight_frostpresence",
        "spellIds": [
          "c8e071c5-7241-4291-838b-1a9f7572225e"
        ],
        "talentIds": []
      },
      "d122a0b5-d857-4bc5-a456-c7250f8f6690": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Holy",
        "id": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "shortName": "Holy",
        "icon_name": "spell_holy_guardianspirit",
        "spellIds": [
          "e15425af-a973-4727-92bc-2da86297a934",
          "39e8f6ac-1b91-41e1-9e66-354e1eece56a"
        ],
        "talentIds": [
          "b7d741b8-7ddd-4840-b496-87969ebf28cb"
        ]
      },
      "83b7651d-c296-4a15-9932-b4012144b6ec": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Tank",
        "name": "Protection",
        "id": "83b7651d-c296-4a15-9932-b4012144b6ec",
        "shortName": "Prot",
        "icon_name": "ability_warrior_defensivestance",
        "spellIds": [
          "2e624376-09f7-4ca3-bbb5-9f98c7b16adc"
        ],
        "talentIds": []
      },
      "e1af3b62-ddf5-4369-a528-dab8ab94d366": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Healer",
        "name": "Holy",
        "id": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "shortName": "Holy",
        "icon_name": "spell_holy_holybolt",
        "spellIds": [
          "7c262290-fde4-43c7-94a9-7b9e87435965",
          "680e990b-3b4a-4d4b-9b08-c5a8f31ce59e",
          "63ad52fb-d45d-4109-883f-8bcb7f993af6",
          "46d09b2f-e027-4d72-a759-34b409049438"
        ],
        "talentIds": [
          "a40a3036-dcbe-4962-9495-2bfe0a1bd5e5",
          "816d8c3d-7227-4c6a-856e-7d1b4989923b"
        ]
      },
      "1df0b300-a31e-4ebc-be57-a909f82bab4b": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Ranged DPS",
        "name": "Elemental",
        "id": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "shortName": "Ele",
        "icon_name": "spell_nature_lightning",
        "spellIds": [
          "2d2e65f5-115f-4460-86b6-f5e190d0e914"
        ],
        "talentIds": []
      },
      "e92b34bc-aa34-4579-a543-2ece2545d981": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Arms",
        "id": "e92b34bc-aa34-4579-a543-2ece2545d981",
        "shortName": "Arms",
        "icon_name": "ability_warrior_savageblow",
        "spellIds": [
          "33a6e8c9-1da0-4d1e-9b4b-51f7ac55ab5c"
        ],
        "talentIds": []
      },
      "08853913-0c47-4ca1-aec0-e93206a6ee45": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "role": "Melee DPS",
        "name": "Havoc",
        "id": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "shortName": "Havoc",
        "icon_name": "ability_demonhunter_specdps",
        "spellIds": [
          "d587377a-5717-430f-8401-58de74f9fda8"
        ],
        "talentIds": []
      },
      "51daa0f0-df16-4983-ae44-e11b5f9b3edb": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Healer",
        "name": "Restoration",
        "id": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "shortName": "Resto",
        "icon_name": "spell_nature_magicimmunity",
        "spellIds": [
          "ef87cf2e-147e-424f-af96-6cd5620175ba",
          "11af8b5c-dc51-4b41-8ad8-4f90310e0a60",
          "b68e0821-b1f8-40b6-8b92-233b1f5e7f2e",
          "56031ab6-2269-4437-89f3-5c6ee81709fa",
          "7559cc30-510a-4117-9510-4895c293f22d"
        ],
        "talentIds": [
          "22efd01f-1258-42ef-9b49-836f9bd1e781",
          "c89be67f-c5b1-4fab-a510-6593c131dd6e",
          "c283517a-1dfa-4a5b-acb8-5e707dd66438"
        ]
      },
      "575905ae-cdc7-44c8-946c-861d50111b6d": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Melee DPS",
        "name": "Feral",
        "id": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "shortName": "Feral",
        "icon_name": "ability_druid_catform",
        "spellIds": [
          "d2acd5d9-d46f-409b-a1db-b5d5d8fdd996"
        ],
        "talentIds": []
      },
      "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Melee DPS",
        "name": "Enhancement",
        "id": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "shortName": "Enh",
        "icon_name": "spell_shaman_improvedstormstrike",
        "spellIds": [
          "3ac0cbc8-4887-4e69-b228-bd7a68813f88"
        ],
        "talentIds": []
      },
      "da2dc773-9412-4b11-ab2b-7d06e200b9d3": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "role": "Healer",
        "name": "Mistweaver",
        "id": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "shortName": "MW",
        "icon_name": "spell_monk_mistweaver_spec",
        "spellIds": [
          "517385d3-6111-475d-b80e-1a83b23e7aad",
          "1f659edd-16ce-4899-ab1d-2ba9b1611288",
          "82cdb567-8a7a-437b-934c-d407596754d2"
        ],
        "talentIds": [
          "12fd7fd0-3392-45aa-ac5d-ef5a16675b6c"
        ]
      },
      "1b478900-c50e-49f6-b9b1-d2fedfb10c2b": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Unholy",
        "id": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b",
        "shortName": "Unholy",
        "icon_name": "spell_deathknight_unholypresence",
        "spellIds": [
          "a97eab84-dfcb-497a-b80c-1efc391fd726"
        ],
        "talentIds": []
      },
      "34735ecf-bf9e-4225-bb6e-ee617b024b70": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Tank",
        "name": "Blood",
        "id": "34735ecf-bf9e-4225-bb6e-ee617b024b70",
        "shortName": "Blood",
        "icon_name": "spell_deathknight_bloodpresence",
        "spellIds": [
          "5aa18ab8-1710-4a4d-bd0e-749e374b105e"
        ],
        "talentIds": []
      },
      "48c27d79-2cc2-4674-bfd0-9a471f6c7ced": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Ranged DPS",
        "name": "Shadow",
        "id": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "shortName": "Shadow",
        "icon_name": "spell_shadow_shadowwordpain",
        "spellIds": [
          "fb68bbab-23dd-4d0e-a018-cb98ed6816d9"
        ],
        "talentIds": []
      },
      "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Fury",
        "id": "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d",
        "shortName": "Fury",
        "icon_name": "ability_warrior_innerrage",
        "spellIds": [
          "9a045fe3-2df8-41bc-bb49-3885af435509"
        ],
        "talentIds": []
      }
    },
    "patchInfo": {
      "buildVersion": "901_2"
    },
    "talentsById": {
      "22efd01f-1258-42ef-9b49-836f9bd1e781": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ancestral Protection Totem",
        "id": "22efd01f-1258-42ef-9b49-836f9bd1e781",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "69341f1a-6471-4a2c-bf46-b17b254fee3f": {
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Mindbender",
        "id": "69341f1a-6471-4a2c-bf46-b17b254fee3f",
        "shortName": "Fiend",
        "icon_name": "spell_shadow_soulleech_3",
        "game_id": 123040
      },
      "eb1dec13-e58d-4f57-96e7-668749613440": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Incarnation: Tree of Life",
        "id": "eb1dec13-e58d-4f57-96e7-668749613440",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "c89be67f-c5b1-4fab-a510-6593c131dd6e": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ascendance",
        "id": "c89be67f-c5b1-4fab-a510-6593c131dd6e",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "c283517a-1dfa-4a5b-acb8-5e707dd66438": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Wind Rush Totem",
        "id": "c283517a-1dfa-4a5b-acb8-5e707dd66438",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "bae29c2a-4e98-4335-a4e1-196ba905cace": {
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Evangelism",
        "id": "bae29c2a-4e98-4335-a4e1-196ba905cace",
        "shortName": "Evan",
        "icon_name": "spell_holy_divineillumination",
        "game_id": 246287
      },
      "a40a3036-dcbe-4962-9495-2bfe0a1bd5e5": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Avenging Crusader",
        "id": "a40a3036-dcbe-4962-9495-2bfe0a1bd5e5",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      },
      "816d8c3d-7227-4c6a-856e-7d1b4989923b": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Holy Avenger",
        "id": "816d8c3d-7227-4c6a-856e-7d1b4989923b",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      },
      "3e09a8a9-f387-4883-a621-9d984b9ea13e": {
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Spirit Shell",
        "id": "3e09a8a9-f387-4883-a621-9d984b9ea13e",
        "shortName": "Shell",
        "icon_name": "ability_shaman_astralshift",
        "game_id": 109964
      },
      "9816f40b-2412-4616-9960-63a6551fe943": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Inner Peace",
        "id": "9816f40b-2412-4616-9960-63a6551fe943",
        "shortName": "IP",
        "icon_name": "ability_druid_dreamstate",
        "game_id": 197073
      },
      "12fd7fd0-3392-45aa-ac5d-ef5a16675b6c": {
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Invoke Chi-Ji, the Red Crane",
        "id": "12fd7fd0-3392-45aa-ac5d-ef5a16675b6c",
        "shortName": "Chi-ji",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "b7d741b8-7ddd-4840-b496-87969ebf28cb": {
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "name": "Holy Word: Salvation",
        "id": "b7d741b8-7ddd-4840-b496-87969ebf28cb",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      }
    },
    "spellsById": {
      "680e990b-3b4a-4d4b-9b08-c5a8f31ce59e": {
        "affectedByModifierIds": [],
        "talentId": "a40a3036-dcbe-4962-9495-2bfe0a1bd5e5",
        "name": "Avenging Crusader",
        "cooldown": 120,
        "id": "680e990b-3b4a-4d4b-9b08-c5a8f31ce59e",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      },
      "f5893bda-6300-4815-bb54-88b5d402b6a5": {
        "affectedByModifierIds": [],
        "name": "Tranquility",
        "cooldown": 180,
        "id": "f5893bda-6300-4815-bb54-88b5d402b6a5",
        "shortName": "Tranq",
        "icon_name": "spell_nature_tranquility",
        "game_id": 740
      },
      "35f8b981-e772-4084-a274-d8b0fd875688": {
        "affectedByModifierIds": [],
        "talentId": "eb1dec13-e58d-4f57-96e7-668749613440",
        "name": "Incarnation: Tree of Life",
        "cooldown": 180,
        "id": "35f8b981-e772-4084-a274-d8b0fd875688",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "d587377a-5717-430f-8401-58de74f9fda8": {
        "affectedByModifierIds": [],
        "name": "Darkness",
        "cooldown": 180,
        "id": "d587377a-5717-430f-8401-58de74f9fda8",
        "shortName": "Dark",
        "icon_name": "ability_demonhunter_darkness",
        "game_id": 196718
      },
      "7c262290-fde4-43c7-94a9-7b9e87435965": {
        "affectedByModifierIds": [],
        "talentId": "816d8c3d-7227-4c6a-856e-7d1b4989923b",
        "name": "Holy Avenger",
        "cooldown": 180,
        "id": "7c262290-fde4-43c7-94a9-7b9e87435965",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      },
      "c8e071c5-7241-4291-838b-1a9f7572225e": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "c8e071c5-7241-4291-838b-1a9f7572225e",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "ef87cf2e-147e-424f-af96-6cd5620175ba": {
        "affectedByModifierIds": [],
        "talentId": "c89be67f-c5b1-4fab-a510-6593c131dd6e",
        "name": "Ascendance",
        "cooldown": 180,
        "id": "ef87cf2e-147e-424f-af96-6cd5620175ba",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "11af8b5c-dc51-4b41-8ad8-4f90310e0a60": {
        "affectedByModifierIds": [],
        "name": "Healing Tide Totem",
        "cooldown": 180,
        "id": "11af8b5c-dc51-4b41-8ad8-4f90310e0a60",
        "shortName": "HTT",
        "icon_name": "ability_shaman_healingtide",
        "game_id": 108280
      },
      "321d761a-2d39-4dff-a24d-fcb813268dce": {
        "affectedByModifierIds": [],
        "name": "Power Word: Barrier",
        "cooldown": 180,
        "id": "321d761a-2d39-4dff-a24d-fcb813268dce",
        "shortName": "PW:B",
        "icon_name": "spell_holy_powerwordbarrier",
        "game_id": 62618
      },
      "03144576-38ad-4511-81d5-755cdf3662fd": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "03144576-38ad-4511-81d5-755cdf3662fd",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "2d2e65f5-115f-4460-86b6-f5e190d0e914": {
        "affectedByModifierIds": [],
        "talentId": "c283517a-1dfa-4a5b-acb8-5e707dd66438",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "2d2e65f5-115f-4460-86b6-f5e190d0e914",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "63ad52fb-d45d-4109-883f-8bcb7f993af6": {
        "affectedByModifierIds": [],
        "name": "Aura Mastery",
        "cooldown": 180,
        "id": "63ad52fb-d45d-4109-883f-8bcb7f993af6",
        "shortName": "AM",
        "icon_name": "spell_holy_auramastery",
        "game_id": 31821
      },
      "56031ab6-2269-4437-89f3-5c6ee81709fa": {
        "affectedByModifierIds": [],
        "name": "Spirit Link Totem",
        "cooldown": 180,
        "id": "56031ab6-2269-4437-89f3-5c6ee81709fa",
        "shortName": "SLT",
        "icon_name": "spell_shaman_spiritlink",
        "game_id": 98008
      },
      "d2acd5d9-d46f-409b-a1db-b5d5d8fdd996": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "d2acd5d9-d46f-409b-a1db-b5d5d8fdd996",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "7559cc30-510a-4117-9510-4895c293f22d": {
        "affectedByModifierIds": [],
        "talentId": "22efd01f-1258-42ef-9b49-836f9bd1e781",
        "name": "Ancestral Protection Totem",
        "cooldown": 300,
        "id": "7559cc30-510a-4117-9510-4895c293f22d",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "b5b02f28-d5d7-4456-bc5b-d0e61bce57da": {
        "affectedByModifierIds": [],
        "talentId": "69341f1a-6471-4a2c-bf46-b17b254fee3f",
        "name": "Mindbender",
        "cooldown": 60,
        "id": "b5b02f28-d5d7-4456-bc5b-d0e61bce57da",
        "shortName": "Fiend",
        "icon_name": "spell_shadow_soulleech_3",
        "game_id": 123040
      },
      "62704b34-f28b-4567-8bb1-25c36d930c13": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "62704b34-f28b-4567-8bb1-25c36d930c13",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "e15425af-a973-4727-92bc-2da86297a934": {
        "affectedByModifierIds": [],
        "name": "Divine Hymn",
        "cooldown": 180,
        "id": "e15425af-a973-4727-92bc-2da86297a934",
        "shortName": "Hymn",
        "icon_name": "spell_holy_divinehymn",
        "game_id": 64843
      },
      "82cdb567-8a7a-437b-934c-d407596754d2": {
        "affectedByModifierIds": [],
        "talentId": "12fd7fd0-3392-45aa-ac5d-ef5a16675b6c",
        "name": "Invoke Chi-Ji, the Red Crane",
        "cooldown": 180,
        "id": "82cdb567-8a7a-437b-934c-d407596754d2",
        "shortName": "Chi-ji",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "c99f217d-2734-423c-aaee-edc5bdb14f81": {
        "affectedByModifierIds": [],
        "talentId": "bae29c2a-4e98-4335-a4e1-196ba905cace",
        "name": "Evangelism",
        "cooldown": 90,
        "id": "c99f217d-2734-423c-aaee-edc5bdb14f81",
        "shortName": "Evan",
        "icon_name": "spell_holy_divineillumination",
        "game_id": 246287
      },
      "d785b1f4-4e56-48e3-af49-4f0c7c584f16": {
        "affectedByModifierIds": [],
        "name": "Rapture",
        "cooldown": 90,
        "id": "d785b1f4-4e56-48e3-af49-4f0c7c584f16",
        "shortName": "Rapt",
        "replacedByTalentId": "3e09a8a9-f387-4883-a621-9d984b9ea13e",
        "icon_name": "spell_holy_rapture",
        "game_id": 47536
      },
      "fb68bbab-23dd-4d0e-a018-cb98ed6816d9": {
        "affectedByModifierIds": [],
        "name": "Vampiric Embrace",
        "cooldown": 120,
        "id": "fb68bbab-23dd-4d0e-a018-cb98ed6816d9",
        "shortName": "VE",
        "icon_name": "spell_shadow_unsummonbuilding",
        "game_id": 15286
      },
      "46d09b2f-e027-4d72-a759-34b409049438": {
        "affectedByModifierIds": [],
        "name": "Avenging Wrath",
        "cooldown": 120,
        "id": "46d09b2f-e027-4d72-a759-34b409049438",
        "shortName": "Wings",
        "replacedByTalentId": "a40a3036-dcbe-4962-9495-2bfe0a1bd5e5",
        "icon_name": "spell_holy_avenginewrath",
        "game_id": 31884
      },
      "7f8c721f-1f23-43b3-8164-dcc2f2715985": {
        "affectedByModifierIds": [],
        "talentId": "3e09a8a9-f387-4883-a621-9d984b9ea13e",
        "name": "Spirit Shell",
        "cooldown": 60,
        "id": "7f8c721f-1f23-43b3-8164-dcc2f2715985",
        "shortName": "Shell",
        "icon_name": "ability_shaman_astralshift",
        "game_id": 109964
      },
      "9bc18005-3fb3-435d-9eb6-bc70ad7dcd7f": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 60,
        "id": "9bc18005-3fb3-435d-9eb6-bc70ad7dcd7f",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "3ac0cbc8-4887-4e69-b228-bd7a68813f88": {
        "affectedByModifierIds": [],
        "talentId": "c283517a-1dfa-4a5b-acb8-5e707dd66438",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "3ac0cbc8-4887-4e69-b228-bd7a68813f88",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "33a6e8c9-1da0-4d1e-9b4b-51f7ac55ab5c": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "33a6e8c9-1da0-4d1e-9b4b-51f7ac55ab5c",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "9a045fe3-2df8-41bc-bb49-3885af435509": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "9a045fe3-2df8-41bc-bb49-3885af435509",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "b68e0821-b1f8-40b6-8b92-233b1f5e7f2e": {
        "affectedByModifierIds": [],
        "talentId": "c283517a-1dfa-4a5b-acb8-5e707dd66438",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "b68e0821-b1f8-40b6-8b92-233b1f5e7f2e",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "1f659edd-16ce-4899-ab1d-2ba9b1611288": {
        "affectedByModifierIds": [],
        "name": "Invoke Yu'lon, the Jade Serpent",
        "cooldown": 180,
        "id": "1f659edd-16ce-4899-ab1d-2ba9b1611288",
        "shortName": "Yulon",
        "replacedByTalentId": "12fd7fd0-3392-45aa-ac5d-ef5a16675b6c",
        "icon_name": "ability_monk_dragonkick",
        "game_id": 322118
      },
      "a97eab84-dfcb-497a-b80c-1efc391fd726": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "a97eab84-dfcb-497a-b80c-1efc391fd726",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "2e624376-09f7-4ca3-bbb5-9f98c7b16adc": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "2e624376-09f7-4ca3-bbb5-9f98c7b16adc",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "39e8f6ac-1b91-41e1-9e66-354e1eece56a": {
        "affectedByModifierIds": [],
        "talentId": "b7d741b8-7ddd-4840-b496-87969ebf28cb",
        "name": "Holy Word: Salvation",
        "cooldown": 720,
        "id": "39e8f6ac-1b91-41e1-9e66-354e1eece56a",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      },
      "517385d3-6111-475d-b80e-1a83b23e7aad": {
        "affectedByModifierIds": [],
        "name": "Revival",
        "cooldown": 180,
        "id": "517385d3-6111-475d-b80e-1a83b23e7aad",
        "shortName": "Rev",
        "icon_name": "spell_monk_revival",
        "game_id": 115310
      },
      "9009c1c3-579e-4900-8cab-83f0a19a3cf9": {
        "affectedByModifierIds": [],
        "name": "Shadowfiend",
        "cooldown": 180,
        "id": "9009c1c3-579e-4900-8cab-83f0a19a3cf9",
        "shortName": "Fiend",
        "replacedByTalentId": "69341f1a-6471-4a2c-bf46-b17b254fee3f",
        "icon_name": "spell_shadow_shadowfiend",
        "game_id": 34433
      },
      "5aa18ab8-1710-4a4d-bd0e-749e374b105e": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "5aa18ab8-1710-4a4d-bd0e-749e374b105e",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      }
    },
    "changelog": [
      "No changelog, too much to list, all of Shadowlands."
    ],
    "modifiersById": {}
  }
`)
